import { IConfigService } from '@cs/performance-manager/shared';
import { Observable }     from 'rxjs';
import { Result }         from '@cs/core';

export abstract class ManagedByMeConfigService implements IConfigService {
  moduleName = 'managed-by-me';

  abstract getResources(resourceTypeId: number): Observable<Result<any>>;
}
